export default "__VITE_ASSET__DVV0nG_J__"